
export function openDb(name, version, upgradeCallback: (this: IDBOpenDBRequest, e: IDBVersionChangeEvent) => void): Promise<IDBDatabase> {
    const rq = globalThis.indexedDB.open(name, version);
    rq.onupgradeneeded = upgradeCallback;
    return idbWrapRequest(rq);
}

export function idbGet<T>(db: IDBDatabase, objectStore: string, key: IDBValidKey | IDBKeyRange): Promise<T> {
    return idbWrapRequest(db.transaction(objectStore).objectStore(objectStore).get(key));
}

export function idbPut(db: IDBDatabase, objectStore: string, data: any): Promise<IDBValidKey> {
    return idbWrapRequest(db.transaction(objectStore, "readwrite").objectStore(objectStore).put(data));
}

export async function idbUpdate<T>(db: IDBDatabase, objectStore: string, key: IDBValidKey | IDBKeyRange, modifier: (data: T | undefined) => T): Promise<T> {
    const store = db
        .transaction(objectStore, "readwrite")
        .objectStore(objectStore);
    let item = await idbWrapRequest(store.get(key)) as T | undefined;
    item = modifier(item);
    await idbWrapRequest(store.put(item));
    return item;
}

export function idbWrapRequest<T>(request: IDBRequest<T>): Promise<T> {
    return new Promise((resolve, reject) => {
        request.onsuccess = () => {
            resolve(request.result);
        };
        request.onerror = () => {
            reject(request.error);
        };
    });
}

export function idbSearch(db: IDBDatabase, objectStore: string, filterFunction: (cursor: IDBCursorWithValue) => boolean | object, query?: IDBKeyRange, limit: number = 0, index: string | undefined = undefined, direction: IDBCursorDirection = 'next', cancel?: AbortSignal): Promise<any[]> {
        return new Promise((resolve, reject) => {
            var items : any[] = [];
            let request = index
                ? db.transaction(objectStore).objectStore(objectStore).index(index).openCursor(query, direction)
                : db.transaction(objectStore).objectStore(objectStore).openCursor(query, direction);
            request.onsuccess = (event) => {
                    if (cancel?.aborted) reject(new DOMException('Search cancelled.', 'AbortError'));
                    if (request.result) {
                        var result = filterFunction(request.result);
                        if (result)
                            items.push(result === true ? request.result.value : result);
                        if (result === null || (limit && items.length >= limit))
                            resolve(items);
                        else
                            request.result.continue();
                    } else {
                        resolve(items);
                    }
                };
        });
}